import React from 'react';
import './SectionHeader.css'
import '../../root.css'

const SectionHeader = (props) => {
    return ( 
        <div className={props.SectionStyle}>
            <p className='SectionTitle'> {props.SectionTitle} <span className='Highlighted'>{props.HighlightedWord}</span></p>
            <p className='SectionP'>
                {props.SectionP}
            </p>
        </div>
     );
}
 
export default SectionHeader;